import React from "react";
import { useCopy } from "../../lib/paymentCheck/i18n.jsx";

/**
 * "Built for people with something to protect" — NEW section (task
 * brief §9). Editorial/architectural card grid, deliberately not a
 * generic rounded-SaaS treatment — square geometry, hairline borders,
 * strong type, consistent with the rest of Art Direction V2.
 *
 * Every bullet is an illustrative example of the kind of situation an
 * audience might bring to us, not a claim of frequency, a real case,
 * or a statistic (see copy.js "audience_*" keys and CLAUDE.md §9's
 * "never fabricate statistics/victim stories" rule).
 */
const CARDS = [
  { titleKey: "audience_card1_title", bullets: ["audience_card1_b1", "audience_card1_b2", "audience_card1_b3", "audience_card1_b4"] },
  { titleKey: "audience_card2_title", bullets: ["audience_card2_b1", "audience_card2_b2", "audience_card2_b3", "audience_card2_b4"] },
  { titleKey: "audience_card3_title", bullets: ["audience_card3_b1", "audience_card3_b2", "audience_card3_b3", "audience_card3_b4"] },
  { titleKey: "audience_card4_title", bullets: ["audience_card4_b1", "audience_card4_b2", "audience_card4_b3", "audience_card4_b4"] },
  { titleKey: "audience_card5_title", bullets: ["audience_card5_b1", "audience_card5_b2", "audience_card5_b3", "audience_card5_b4"] },
  { titleKey: "audience_card6_title", bullets: ["audience_card6_b1", "audience_card6_b2", "audience_card6_b3", "audience_card6_b4"] },
];

export default function AudienceSection() {
  const t = useCopy();

  return (
    <section className="pc-audience pc-zone--white">
      <div className="pc-container">
        <p className="pc-kicker pc-kicker--dark">{t("audience_eyebrow")}</p>
        <h2 className="pc-section-title">{t("audience_title")}</h2>
        <p className="pc-lede" style={{ color: "var(--pc-ink-soft)", fontWeight: 400, marginBottom: "var(--pc-space-6)" }}>
          {t("audience_intro")}
        </p>
        <div className="pc-audience__grid">
          {CARDS.map((card) => (
            <article className="pc-audience__card" key={card.titleKey}>
              <h3 className="pc-audience__card-title">{t(card.titleKey)}</h3>
              <ul className="pc-audience__list">
                {card.bullets.map((key) => (
                  <li key={key}>{t(key)}</li>
                ))}
              </ul>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
